// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.


// global.$ = require("jquery")
// import 'jquery'


import 'jquery-ui'

// import 'popper.js'
// import 'trix'
// import 'channels'
import '../channels/consumer'
import '../channels/directmessage_channel'
import '../channels/index'
import '../channels/room_channel'



import 'bootstrap'
import 'bootstrap-sass'
import '../js/application'
import '../css/application.scss'
import 'trix/dist/trix.css'
import '../css/actiontext.scss'



// const images = require.context('../images', true)
import Rails from 'rails-ujs'
import "chartkick/chart.js"
import "chartkick/highcharts"




Rails.start();

// require("turbolinks").start()

require("@rails/activestorage").start()
require("channels")
require("trix")
require("@rails/actiontext")



// require("jquery")

// window.jQuery = $;
// window.$ = $;
window.jQuery = window.$ = require('jquery')

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)



// import '../channels/consumer.js'
// import '../channels/directmessage_channel.js'
// import '../channels/index.js'
// import '../channels/room_channel.js'
//
//
// import '../js/cable'
// import '../js/challenge_threads'

//
// import '../js/trix-core'
// import '../js/trix'

import '../js/jquery.raty'
// import '../js/sidebar/slide_sidebar'


import '../js/sidebar-add'

import '../js/tag-it'
import '../js/tag-it-add'

import '../js/challenges'
import '../js/user_score'
import '../js/bootstrap-tooltip'
import '../js/autonumeric'

require("autonumeric")

require("flatpickr")
import flatpickr from "flatpickr";
//document.addEventListener("turbolinks:load", () => {

//    flatpickr("[class='flatpickr']", {})
//})

document.addEventListener('DOMContentLoaded', function() {
  flatpickr("[class='flatpickr']", {});
})


// stylesheets
require("../css/application.scss")




// import 'moment/moment'
// import 'tempusdominus-bootstrap-4'
// import '../js/datetimepicker-add'
